export default __webpack_public_path__ + "static/media/152.0c8c201f.png";